module.exports = __webpack_public_path__ + "static/media/img-cole-veloe@3x.8618f676.png";